import config from 'api/config';
import fetchApi from 'api/fetchApi';
import { TFieldValue } from 'components/Forms';

export interface IUserParams {
  companyId: number;
  fields: Record<string, TFieldValue>;
}

interface ICompaniesPATCHReturnType {
  success: boolean;
  message: string;
}

const companiesPATCH = async (
  args: IUserParams,
): Promise<ICompaniesPATCHReturnType> => {
  const response = await fetchApi({
    method: 'PATCH',
    path: `${config.companies}${args.companyId}/`,
    payload: { ...args.fields },
  });

  const { success, status, payload } = response;

  if (success && status === 200) {
    return {
      success: true,
      message: 'Company edited.',
    };
  }
  if (payload instanceof Object) {
    let message = '';
    Object.entries(payload).forEach((entry) => {
      const [name, val] = entry as [string, string | string[]];
      message += `${name.toUpperCase()} - ${
        val instanceof Array ? val.join('') : JSON.stringify(val)
      } `;
    });
    message = message ? `Errors! ${message}` : 'Something went wrong';
    return {
      success: false,
      message,
    };
  }
  return {
    success: false,
    message: 'Something went wrong',
  };
};

export default companiesPATCH;
